import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _containsHooks(target) {
  return (target === null || target === void 0 ? void 0 : target.__hooks__) != null;
}

export function addHook(target, hookName, hookFn) {
  var _target$__hooks__$get;

  if (!_containsHooks(target)) {
    Object.defineProperty(target, '__hooks__', {
      enumerable: false,
      configurable: false,
      writable: false,
      value: new Map()
    });
  }

  var existingHooks = (_target$__hooks__$get = target.__hooks__.get(hookName)) !== null && _target$__hooks__$get !== void 0 ? _target$__hooks__$get : [];

  target.__hooks__.set(hookName, [].concat(_toConsumableArray(existingHooks), [hookFn]));
}
export function runHooks(_x, _x2) {
  return _runHooks.apply(this, arguments);
}

function _runHooks() {
  _runHooks = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(target, hookName) {
    var hooks, results, _iterator, _step, hook;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (_containsHooks(target)) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", []);

          case 2:
            hooks = target.__hooks__.get(hookName);

            if (!(hooks == null)) {
              _context.next = 5;
              break;
            }

            return _context.abrupt("return", []);

          case 5:
            results = [];
            _iterator = _createForOfIteratorHelper(hooks);
            _context.prev = 7;

            _iterator.s();

          case 9:
            if ((_step = _iterator.n()).done) {
              _context.next = 18;
              break;
            }

            hook = _step.value;
            _context.t0 = results;
            _context.next = 14;
            return hook.call(target);

          case 14:
            _context.t1 = _context.sent;

            _context.t0.push.call(_context.t0, _context.t1);

          case 16:
            _context.next = 9;
            break;

          case 18:
            _context.next = 23;
            break;

          case 20:
            _context.prev = 20;
            _context.t2 = _context["catch"](7);

            _iterator.e(_context.t2);

          case 23:
            _context.prev = 23;

            _iterator.f();

            return _context.finish(23);

          case 26:
            return _context.abrupt("return", results);

          case 27:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[7, 20, 23, 26]]);
  }));
  return _runHooks.apply(this, arguments);
}

export function runHooksSync(target, hookName) {
  if (!_containsHooks(target)) return [];

  var hooks = target.__hooks__.get(hookName);

  if (hooks == null) return [];
  return hooks.map(function (hook) {
    return hook.call(target);
  });
}
export function hasHooks(target, hookName) {
  if (!_containsHooks(target)) return false;
  if (hookName == null) return _containsHooks(target);
  return target.__hooks__.has(hookName) && target.__hooks__.get(hookName).length > 0;
}